import axios from 'axios';

export const loginAndStoreToken = async () => {
  try {
    console.log('Starting loginAndStoreToken...');

    // Clear any existing tokens before attempting login
    localStorage.removeItem('token');
    localStorage.removeItem('token_expiry');

    // Log the environment (remove in production)
    console.log('Login attempt:', {
      environment: process.env.NODE_ENV,
      baseUrl: process.env.REACT_APP_BACKEND_URL
    });

    console.log('Making login request to backend...');

    // Call our backend auth endpoint
    const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5001';
    const response = await axios.post(`${backendUrl}/api/auth`, {}, {
      headers: {
        'Content-Type': 'application/json'
      }
    });

    console.log('Backend login response received:', {
      success: response.data?.success,
      hasToken: !!response.data?.token,
      hasExpiry: !!response.data?.tokenExpiryUtc
    });

    if (!response.data?.success || !response.data?.token) {
      console.error('Invalid backend login response:', response.data);
      throw new Error('Invalid login response: No token received');
    }

    const { token, tokenExpiryUtc } = response.data;

    // Store token and expiry
    localStorage.setItem('token', token);
    localStorage.setItem('token_expiry', tokenExpiryUtc);

    // Verify storage
    const storedToken = localStorage.getItem('token');
    const storedExpiry = localStorage.getItem('token_expiry');

    console.log('Token storage verification:', {
      tokenStored: !!storedToken,
      tokenLength: storedToken?.length,
      expiryStored: !!storedExpiry
    });

    if (!storedToken || !storedExpiry) {
      throw new Error('Token storage verification failed');
    }

    // Log successful login (remove in production)
    console.log('Successfully authenticated with ResDiary API via backend');
    return token;
  } catch (error) {
    console.error('Login failed:', {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status
    });

    // Clear any existing invalid tokens
    localStorage.removeItem('token');
    localStorage.removeItem('token_expiry');

    if (!error.response) {
      throw new Error('Network error. Please check your internet connection and try again.');
    }

    // Handle backend error responses
    if (error.response.data?.error) {
      throw new Error(error.response.data.error);
    }

    switch (error.response.status) {
      case 400:
        throw new Error('Invalid credentials. Please check server configuration.');
      case 401:
        throw new Error('Authentication failed. Please try again.');
      case 403:
        throw new Error('Access denied. Please check server permissions.');
      case 404:
        throw new Error('Authentication service not found. Please check server configuration.');
      case 500:
        throw new Error('Server configuration error. Please contact support.');
      case 502:
        throw new Error('External service error. Please try again later.');
      case 503:
        throw new Error('Service temporarily unavailable. Please try again later.');
      default:
        throw new Error(error.response?.data?.error || 'Authentication failed. Please try again.');
    }
  }
};

export const isTokenValid = () => {
  try {
    const token = localStorage.getItem('token');
    const expiry = localStorage.getItem('token_expiry');

    if (!token || !expiry) {
      return false;
    }

    const now = new Date();
    const expiryDate = new Date(expiry);

    // Add 5-minute buffer to prevent edge cases
    const bufferTime = 5 * 60 * 1000; // 5 minutes in milliseconds
    if (now >= expiryDate - bufferTime) {
      // Clear expired token
      localStorage.removeItem('token');
      localStorage.removeItem('token_expiry');
      return false;
    }

    return true;
  } catch (error) {
    console.error('Error checking token validity:', error);
    return false;
  }
};

export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('token_expiry');
};
